import {AnyAction, configureStore, getDefaultMiddleware, ThunkAction} from '@reduxjs/toolkit';
import rootReducer from '~/redux/root-reducer';
import {registerSchemas} from '~/redux/schema';
import {createStateSyncMiddleware, initMessageListener} from 'redux-state-sync';

const config = {
  blacklist: [
    'uis/setShowApptCreationModal',
    'uis/notify',
    'uis/setMenuSearch',
    'uis/setTitleHeader',
    'uis/setSidebarSize',
    'uis/setShowVideoCallModal',
    'uis/setShowMedicalFormModal',
    'uis/setConsNoteModal',
    'doctorAppointments/setPrescription',
    'questionnaires/setQuestionnaireAnswer',
    'questionnaires/setMedicalUUID',
    'questionnaires/setAnswerOrder',
    'questionnaires/setBackAnswerOrder',
    'questionnaires/setUserLocalPhotoURL',
    'questionnaires/questionnaire/withoutNormalize/submitOrLog/post/fulfilled',
  ],
};

const middleware = getDefaultMiddleware().concat(createStateSyncMiddleware(config));

// const middleware: ConfigureStoreOptions['middleware'] = getDefaultMiddleware =>
//   getDefaultMiddleware().concat(createStateSyncMiddleware());

const rootStore = configureStore({
  reducer: rootReducer,
  middleware,
});

export type AppDispatch = typeof rootStore.dispatch;
export type AppThunk = AnyAction | ThunkAction<void, any, undefined, AnyAction>;

registerSchemas();

initMessageListener(rootStore);

export default rootStore;
